import React from 'react';
import { Input } from '../ui/input';
import { money } from './poShared';

export const calcPoTotals = (form) => {
  const subtotal = form.lines.reduce((s, l) => s + Number(l.quantity || 0) * Number(l.unit_cost || 0), 0);
  const ship = Number(form.shipping_cost || 0);
  const gst = Math.round((subtotal + ship) * Number(form.gst_pct || 0)) / 100;
  const pst = Math.round(subtotal * Number(form.pst_pct || 0)) / 100;
  return { subtotal, ship, gst, pst, total: subtotal + ship + gst + pst };
};

const pctInput = 'w-20 h-8 rounded-sm mono text-right';

export const PoTotals = ({ form, setForm, editable, po }) => {
  const live = calcPoTotals(form);
  // Locked POs show the stored amounts so the page always matches the print.
  const t = !editable && po ? { ...live, gst: Number(po.gst_amount ?? po.tax_amount ?? 0), pst: Number(po.pst_amount || 0), total: Number(po.total || 0) } : live;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <div className="w-80 space-y-1.5 text-sm" data-testid="po-totals">
      <div className="flex justify-between"><span>Subtotal</span><span className="mono">{money(t.subtotal)}</span></div>
      <div className="flex justify-between"><span>Shipping</span><span className="mono" data-testid="po-shipping-total">{money(t.ship)}</span></div>
      <div className="flex justify-between items-center gap-2">
        <span className="flex items-center gap-1.5">GST <Input type="number" min="0" max="100" step="0.01" value={form.gst_pct} onChange={set('gst_pct')} disabled={!editable} className={pctInput} data-testid="po-gst-rate" />%</span>
        <span className="mono" data-testid="po-gst-amount">{money(t.gst)}</span>
      </div>
      <p className="text-[10px] text-slate-400 -mt-1">GST is charged on items + shipping</p>
      <div className="flex justify-between items-center gap-2">
        <span className="flex items-center gap-1.5">
          <select value={form.pst_label} onChange={set('pst_label')} disabled={!editable} className="h-8 border border-slate-200 rounded-sm px-1 text-xs bg-white" data-testid="po-pst-label">
            {['PST', 'QST', 'RST'].map(x => <option key={x}>{x}</option>)}
          </select>
          <Input type="number" min="0" max="100" step="0.01" value={form.pst_pct} onChange={set('pst_pct')} disabled={!editable} className={pctInput} data-testid="po-pst-rate" />%
        </span>
        <span className="mono" data-testid="po-pst-amount">{money(t.pst)}</span>
      </div>
      <div className="flex justify-between bg-slate-900 text-white px-2 py-1.5 rounded-sm"><span className="font-semibold">Total ({form.currency || 'CAD'})</span><span className="mono font-bold" data-testid="po-total">{money(t.total)}</span></div>
    </div>
  );
};

export default PoTotals;
